import { Settings2, Building, Calendar, Bus } from 'lucide-react';
import { PageHeader } from '../components/common/PageHeader';
import { DataCard } from '../components/common/DataCard';
import { StatsCard } from '../components/common/StatsCard';

export function OperationsPage() {
  return (
    <div data-testid="operations-page" className="space-y-8 animate-fade-in">
      <PageHeader
        title="Operations"
        description="Manage facilities, transport, events, and school operations."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatsCard title="Facilities" value="0" icon={Building} delay={0} />
        <StatsCard title="Transport Routes" value="0" icon={Bus} delay={0.05} />
        <StatsCard title="Events" value="0" icon={Calendar} delay={0.1} />
        <StatsCard title="Active Alerts" value="0" icon={Settings2} delay={0.15} />
      </div>

      <DataCard className="text-center py-16" delay={0.2}>
        <Settings2 className="w-16 h-16 mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold mb-2">Operations Module</h3>
        <p className="text-muted-foreground max-w-md mx-auto">
          Facilities, transport routes, and events have not been configured yet. Once operational data is added, it will be managed from here.
        </p>
      </DataCard>
    </div>
  );
}
